/** The header's previous / next arrows around the month or week on screen. */
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { CSSProperties } from 'react';

import { PILL_BOX } from './workshops-calendar-header-styles';

const NAV_BTN: CSSProperties = {
  width: 22,
  height: 22,
  borderRadius: 999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--nb-muted)',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
};

export function WorkshopsCalendarDateNavigator({
  label,
  onNav,
}: {
  label: string;
  onNav: (dir: 'prev' | 'next') => void;
}) {
  return (
    <div style={PILL_BOX}>
      <button type="button" onClick={() => onNav('prev')} style={NAV_BTN} title="Previous">
        <ChevronLeft size={11} strokeWidth={2} />
      </button>
      <span
        className="nb-tabular"
        style={{
          padding: '0 10px',
          minWidth: 100,
          textAlign: 'center',
          fontSize: 11.5,
          fontWeight: 600,
          color: 'var(--nb-ink)',
        }}
      >
        {label}
      </span>
      <button type="button" onClick={() => onNav('next')} style={NAV_BTN} title="Next">
        <ChevronRight size={11} strokeWidth={2} />
      </button>
    </div>
  );
}
